import { styled } from '@mui/material/styles';
import React from 'react';
import { StyledToolbar } from './EnrollHeader';
import { Box } from '@mui/material';
import { TENANT } from 'new/tenants';
const { pngLogo } = TENANT.logos;

type Props = {
  topTitle?: string;
  bottomTitle: string;
};

const SetupToolbar = styled(StyledToolbar)(({ theme }) => ({
  justifyContent: 'flex-start',
  alignItems: 'center',

  '& .divider': {
    width: 1,
    height: 55,
    margin: theme.spacing(2, 2),
    backgroundColor: '#fff',
  },

  '& .titleContainer': {
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',

    'p:first-of-type': {
      fontWeight: 'bold',
      margin: 0,
      marginTop: -4,
    },

    'p:nth-of-type(2)': {
      fontSize: '1.688rem',
      lineHeight: '1.8rem',
      margin: 0,
    },
  },
}));

const SetupHeader: React.FC<Props> = ({ topTitle, bottomTitle }) => {
  return (
    <SetupToolbar>
      <img width={200} src={pngLogo} alt="logo" />
      <Box className="divider" />
      <Box className="titleContainer">
        <p>{topTitle}</p>
        <p>{bottomTitle}</p>
      </Box>
    </SetupToolbar>
  );
};

export default SetupHeader;
